export default function () {
  /* 表格列头 */
  return [
    {
      label: "",
      type: "selection",
      width: 50,
    },
    {
      label: "门店ID",
      prop: "store_id",
      width: 100,
    },
    {
      label: "店铺名称",
      prop: "store_name",
      slots: "storeName",
      minWidth: 360,
    },
    {
      label: "卡种",
      prop: "type",
      slots: "type",
      width: 100,
    },
    {
      label: "卡号",
      prop: "vip_number",
      width: 130,
    },
    {
      label: "姓名",
      prop: "user_name",
      width: 100,
    },
    {
      label: "手机号",
      prop: "user_phone",
      width: 130,
    },
    {
      label: "性别",
      prop: "sex",
      width: 80,
    },
    {
      label: "余额",
      prop: "money",
      slots: "money",
      width: 110,
    },
    {
      label: "备注",
      prop: "msg",
      slots: "msg",
      width: 90,
    },
    {
      label: "开卡时间",
      prop: "create_time",
      width: 180,
    },
  ];
}
